import { useState, useLayoutEffect } from 'react';
import { portalUserService, BrandVersion } from '../services';

/**
 * Hook to subscribe to brand version changes from portalUserService.
 * Syncs in useLayoutEffect so a brand set during another layout effect
 * (e.g. signup CSP brand gate) is visible before first paint.
 */
export function useBrandVersion(): BrandVersion {
    const [brand, setBrand] = useState<BrandVersion>(() => portalUserService.getBrandVersion());

    useLayoutEffect(() => {
        setBrand(portalUserService.getBrandVersion());
        return portalUserService.subscribeToBrand(setBrand);
    }, []);

    return brand;
}
